var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookPost = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 25,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 24 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#265BFA",
  d: "M23.998 12.5c0-6.628-5.372-12-11.999-12S0 5.872 0 12.5c0 5.988 4.388 10.952 10.124 11.852v-8.384H7.078v-3.469h3.046V9.856c0-3.008 1.792-4.669 4.532-4.669 1.313 0 2.686.234 2.686.234v2.953H15.83c-1.49 0-1.955.925-1.955 1.874V12.5h3.328l-.532 3.469h-2.796v8.384c5.736-.9 10.124-5.864 10.124-11.853"
})));
export default SvgFacebookPost;